
import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Search, Import } from 'lucide-react';
import { Button } from '@/components/ui/button';

const NoRecipesMessage: React.FC = () => {
  return (
    <div className="flex flex-col items-center text-center py-12">
      <div className="bg-gray-50 rounded-full p-6 mb-6">
        <BookOpen className="h-16 w-16 text-primary" />
      </div>
      <h2 className="text-2xl font-bold mt-2 mb-3">No Recipes Found</h2>
      <p className="text-muted-foreground mb-8 max-w-md">
        To start planning your meals, you'll need to add some recipes first.
        You can browse recipe ideas or import your favorite recipes from the web.
      </p>
      <div className="flex flex-col sm:flex-row gap-4">
        <Link to="/recipe-finder">
          <Button className="gap-2">
            <Search className="h-4 w-4" />
            Find Recipes
          </Button>
        </Link>
        <Link to="/import-recipes">
          <Button variant="outline" className="gap-2">
            <Import className="h-4 w-4" />
            Import Recipe from URL
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default NoRecipesMessage;
